// extracted by mini-css-extract-plugin
module.exports = {"registerCards":"RegisterCards_registerCards__1rWVg","cardsContainer":"RegisterCards_cardsContainer__3Jckq","card":"RegisterCards_card__2qlc6"};